const Home = resolve => require.ensure([], () => resolve(require('@/views/home/home.vue')), 'Home')


export default [
    {
        path: '/',
        redirect: { name: 'home' }
    },
    {
        path: '/home',
        component: Home,
        name: 'home',
        meta: {
            name: '首页',
            title: '百驿专线查查',
            icon: 'fa fa-home',
            isWXShare:true
        }
    }

]